import Dashboard from "../dashboard/src/pages/dashboard"
export default Dashboard
